import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { saudiRiyalIcon } from 'src/app/icons/saudi_riyal';

@Directive({
  selector: '[riyalCurrency]',
})
export class RiyalCurrencyDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    const host: HTMLElement = this.el.nativeElement;

    this.renderer.setStyle(host, 'direction', 'ltr');
    this.renderer.setStyle(host, 'display', 'inline-flex');
    this.renderer.setStyle(host, 'align-items', 'center');
    this.renderer.setStyle(host, 'gap', '8px');

    const iconWrapper: HTMLElement = this.renderer.createElement('span');
    this.renderer.setStyle(iconWrapper, 'display', 'inline-flex');
    this.renderer.setStyle(iconWrapper, 'align-items', 'center');
    this.renderer.setStyle(iconWrapper, 'flex-shrink', '0');
    this.renderer.setProperty(iconWrapper, 'innerHTML', saudiRiyalIcon.data);

    const svgEl = iconWrapper.querySelector('svg');
    if (svgEl) {
      this.renderer.setStyle(svgEl, 'height', '0.85em');
      this.renderer.setStyle(svgEl, 'width', 'auto');
    }

    this.renderer.insertBefore(host, iconWrapper, host.firstChild);
  }
}
